import React, { useEffect, useState } from 'react';
import PromoBar from '../components/PromoBar';
import Header from '../components/Header';
import Hero from '../components/Hero';
import InfoStrip from '../components/InfoStrip';
import MenuShowcase from '../components/MenuShowcase';
import HowItWorks from '../components/HowItWorks';
import AboutSection from '../components/AboutSection';
import FridgeProgram from '../components/FridgeProgram';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import CartSheet from '../components/CartSheet';
import SEO from '../seo/SEO';
import { buildMenuJsonLd, buildFaqJsonLd } from '../seo/config';
import { MENU_ITEMS, FAQS } from '../mock';

const HOME_SCHEMAS = [buildMenuJsonLd(MENU_ITEMS), buildFaqJsonLd(FAQS)];

export default function Home() {
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('w360_cart');
    if (stored) {
      try {
        setCart(JSON.parse(stored));
      } catch (error) {
        console.error('Failed to restore saved cart from localStorage:', error);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('w360_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => {
    setCart((prev) => {
      const found = prev.find((p) => p.id === item.id);
      if (found) {
        return prev.map((p) => p.id === item.id ? { ...p, qty: p.qty + 1 } : p);
      }
      return [...prev, { ...item, qty: 1 }];
    });
    setCartOpen(true);
  };

  const updateQty = (id, delta) => {
    setCart((prev) =>
      prev
        .map((p) => (p.id === id ? { ...p, qty: Math.max(0, p.qty + delta) } : p))
        .filter((p) => p.qty > 0)
    );
  };

  const clearCart = () => setCart([]);

  const cartCount = cart.reduce((s, i) => s + i.qty, 0);

  return (
    <div className="font-body">
      <SEO
        title="Healthy Catering Chicago — Best Mediterranean Bowls & Plant-Based Catering"
        description="Best Mediterranean bowls in Chicago! Wholesome 360 offers healthy salad wraps and custom grain bowls for office catering and group events. Order fresh, plant-based meals online today!"
        path="/"
        schema={HOME_SCHEMAS}
      />
      <PromoBar />
      <Header cartCount={cartCount} onCartClick={() => setCartOpen(true)} />
      <Hero />
      <InfoStrip />
      <MenuShowcase onAdd={addToCart} />
      <HowItWorks />
      <AboutSection />
      <FridgeProgram />
      <FAQ />
      <CTASection />
      <Footer />
      <CartSheet open={cartOpen} onOpenChange={setCartOpen} cart={cart} updateQty={updateQty} clearCart={clearCart} />
    </div>
  );
}
